import { AgendaItem } from '../store/schema/AgendaItem';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    getCalendarEventItemSubjectText,
    getCalendarEventItemLocationText,
    getCalendarEventItemAriaLabel,
    getCalendarEventItemTitle,
} from 'owa-calendar-event-attributes';

/**
 * Get agenda item based on the given calendar event
 */
export default function getAgendaItem(calendarEvent: CalendarEvent): AgendaItem {
    return {
        id: calendarEvent.ItemId,
        subject: getCalendarEventItemSubjectText(calendarEvent),
        startTime: calendarEvent.Start,
        endTime: calendarEvent.End,
        location: getCalendarEventItemLocationText(calendarEvent),
        isAllDay: calendarEvent.IsAllDayEvent,
        isCancelled: calendarEvent.IsCancelled,
        freeBusyType: calendarEvent.FreeBusyType,
        parentFolderId: calendarEvent.ParentFolderId,
        isRecurring: calendarEvent.CalendarItemType === 'Occurrence',
        isRecurringException: calendarEvent.CalendarItemType === 'Exception',
        isPrivate: calendarEvent.Sensitivity === 'Private',
        ariaLabel: getCalendarEventItemAriaLabel(calendarEvent),
        title: getCalendarEventItemTitle(calendarEvent),
    };
}
